
import { MessageCircle } from "lucide-react";
import AdPanel from "@/components/ads/AdPanel";
import RightSideMenu from "@/components/navigation/RightSideMenu";
import ConversationList from "@/components/messages/ConversationList";

const Messages = () => {
  return (
    <div className="min-h-screen bg-background">
      <RightSideMenu />
      <AdPanel />
      
      <div className="p-4">
        <div className="max-w-md mx-auto">
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              <MessageCircle className="inline-block w-8 h-8 text-primary mr-2" />
              Messages
            </h1>
            <p className="text-muted-foreground">Your conversations</p>
          </div>

          <ConversationList />
        </div>
      </div>
    </div>
  );
};

export default Messages;
